/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import BackButton from 'src/components/UI/CustomUI/atoms/BackButton'
import TabNavigation from 'src/components/UI/CustomUI/organisms/TabNavigation'
import { estimateActions, estimatesActions, itemsActions, siteVisitsActions } from 'src/ducks/actions'
import { employeeIsReadOnly } from 'src/ducks/selectors'
import { Box } from '../../../UI'
import CommentsFab from './CommentsFab'
import ControlButtons from './ControlButtons'
import EstimateTopInfo from './EstimateTopInfo'
import { Attachments, History, Information, Items, Notes, Overview } from './Tabs'
import Communications from './Tabs/Communications'
import HistoryAndComments from './Tabs/HistoryAndComments'
import InspectionItems from './Tabs/InspectionItems'
import { WorkOrdersProvider } from './Tabs/Items/context'

const EstimateView: FC = () => {
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams()
  const [estimateLoading, setEstimateLoading] = useState(true)
  const [, setRelatedEstimatesLoading] = useState(true)
  const [selectedTab, setSelectedTab] = useState<number>()
  const { id } = useParams()
  const navigate = useNavigate()
  const order = searchParams?.get('order') ?? ''

  const isCsmReadOnly = useSelector(employeeIsReadOnly)

  const pageLoading = estimateLoading

  const fetchEstimate = useCallback(() => {
    setEstimateLoading(true)

    if (id) {
      dispatch(
        estimateActions.fetchEstimate(id, (succ: boolean) => {
          setEstimateLoading(false)

          if (!succ) {
            setEstimateLoading(false)
            navigate('/not-found')
          }
          /*      dispatch(itemsActions.fetchItems({
                 params: { jobId: id, status: ITEM_STATUS.COMPLETE }
               }, (_succ: boolean, _count?: number) => {
               })) */
        })
      )
    }
  }, [id])

  const fetchRelatedEstimates = () => {
    setRelatedEstimatesLoading(true)
    if (id) {
      dispatch(
        estimatesActions.fetchRelatedEstimates(id, (succ: boolean) => {
          setRelatedEstimatesLoading(false)
          // if (!succ) {
          //   navigate('/not-found')
          // }
        })
      )
    }
  }

  const fetchSiteVisits = useCallback(() => {
    if (id) {
      dispatch(
        siteVisitsActions.getSiteVisits({ jobId: id })
      )
    }
  }, [id])

  const fetchItems = () => {
    dispatch(itemsActions.fetchItemsByCategory({
      params: { jobId: id, orderId: order }
    }, (_succ) => {
      //setTableLoading(false)
    }))
  }

  const fetchInspectionItems = () => {
    dispatch(itemsActions.fetchInspectionItems({
      params: { jobId: id, orderId: order }
    }, (_succ) => {
      //setTableLoading(false)
    }))
  }

  useEffect(() => {
    fetchEstimate()
    fetchRelatedEstimates()
    fetchSiteVisits()
    fetchItems()
    fetchInspectionItems()
  }, [id])

  const refresh = () => {
    fetchEstimate()
    fetchRelatedEstimates()
    fetchSiteVisits()
    // fetchRepairItems()
  }

  const TABS = [
    { label: 'Overview', content: <Overview /> },
    { label: 'Items', content: <WorkOrdersProvider><Items /></WorkOrdersProvider> },
    { label: 'Inspection Items', content: <InspectionItems /> },
    { label: 'Attachments', content: <Attachments /> },
    { label: 'History', content: <History /> },
    { label: 'Information', content: <Information setPageLoading={setEstimateLoading} /> },
    { label: 'History & Comments', content: <HistoryAndComments /> },
    { label: 'Communications', content: <Communications /> },
    { label: 'Notes', content: <Notes /> },
  ]

  if (isCsmReadOnly) {
    TABS.splice(3, 8)
    TABS.push({ label: 'Information', content: <Information setPageLoading={setEstimateLoading} /> })
  }

  return (
    <>
      {searchParams?.get('from') ? (<BackButton float top='12px' to={'/' + searchParams?.get('from')} />) : (<BackButton float top='12px' />)}
      <Box display='grid' gridTemplateRows='min-content auto' gap={2}>
        <Box padding={selectedTab === 3 ? '24px 24px 0' : 0}><EstimateTopInfo loading={pageLoading} /></Box>
        {!pageLoading && <Box>
          <TabNavigation
            tabs={TABS}
            margin='0'
            style={{ fontSize: 'var(--font-XS)' }}
            defaultActive={parseInt(searchParams?.get('tab') ?? '0')}
            getSelectedTab={(selected) => {
              setSelectedTab(selected)
              const orderId = searchParams.get('order')
              const fromParam = searchParams.get('from')
              const currentParams = Object.fromEntries(searchParams)
              if (fromParam !== null) {
                setSearchParams({ ...currentParams, tab: selected.toString(), from: fromParam }, { replace: true })
              } else {
                const params: any = {
                  ...currentParams,
                  tab: selected.toString(),
                }
                if (orderId && selected === 1) {
                  params.order = orderId
                }
                setSearchParams(params, { replace: true })
              }
            }}
            containerSx={{ padding: selectedTab === 3 ? '0 24px' : 0, margin: '1rem 0 0', display: 'flex', justifyContent: 'space-between' }}
            additionalContent={isCsmReadOnly ? <></> : <ControlButtons refresh={refresh} />}

            tabsStyles={{ width: 'fit-content' }}
          />
          {selectedTab !== 0 && !isCsmReadOnly && <CommentsFab />}
        </Box>}
      </Box>
    </>
  )
}

export default EstimateView
